import { Editor, Text, Range, Transforms, Element } from 'slate';
import { ENTER_KEY_CODE } from '@sdk/common/constants';

import { isBlockActive } from './utils';

export function onEnterKeyDown(
  event: React.KeyboardEvent<HTMLInputElement>,
  editor: Editor,
  submitOnEnter: boolean
): void {
  if (event.which === ENTER_KEY_CODE && (event.shiftKey === true || !submitOnEnter)) {
    const [node] = Editor.nodes(editor, {
      match: (n) => !Editor.isEditor(n) && Text.isText(n),
    });

    const textNode = node?.[0];
    if (
      (isBlockActive(editor, 'block-quote') || isBlockActive(editor, 'code-block')) &&
      Text.isText(textNode)
    ) {
      event.preventDefault();
      Transforms.unwrapNodes(editor, {
        match: (n) => !Editor.isEditor(n) && Element.isElement(n) && n.type === 'paragraph',
      });

      if (textNode.text.endsWith('\n')) {
        const { selection } = editor;
        const end = Range.end(selection);

        Transforms.delete(editor, { at: end, unit: 'character', reverse: true });
        editor.insertNode({ type: 'paragraph', children: [{ text: '' }] });
      } else {
        editor.insertText('\n');
      }
    }
  }
}
